import axios from "axios";

const apiURL = "https://imedia-api.growatiopex.com/playablehub";

// const apiURL = "http://localhost:3000/api";
console.log(apiURL);
const API = axios.create();

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token") || localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

API.interceptors.response.use(
    async (response) => {
        const isTokenExpired = response?.data?.success === false && response?.data?.message === "Invalid or expired token";
        if (isTokenExpired) {
            return handleTokenRefresh(response.config);
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        const isTokenExpired = 
            error.response?.status === 401 || 
            (error.response?.data?.success === false && error.response?.data?.message === "Invalid or expired token");

        if (isTokenExpired && originalRequest && !originalRequest._retry) {
            return handleTokenRefresh(originalRequest);
        }
        return Promise.reject(error);
    }
);

const handleTokenRefresh = async (originalRequest) => {
    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        }).then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return API(originalRequest);
        }).catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    const refreshToken = localStorage.getItem("refresh_token");

    if (!refreshToken) {
        isRefreshing = false;
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject("No refresh token");
    }

    try {
        const res = await axios.post(apiURL + "/refresh-token", { refreshToken });
        if (res.data?.success && res.data?.accessToken) {
            const newAccessToken = res.data.accessToken;
            localStorage.setItem("token", newAccessToken);
            localStorage.setItem("access_token", newAccessToken);

            API.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

            processQueue(null, newAccessToken);
            isRefreshing = false;

            return API(originalRequest);
        } else {
            throw new Error("Refresh failed");
        }
    } catch (refreshErr) {
        processQueue(refreshErr, null);
        isRefreshing = false;
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshErr);
    }
};

export const RefreshTokenAPI = async (data, callback) => {
  const generateRefreshToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token")
    try {
      const response = await fetch(apiURL+"/refresh-token", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken: refreshToken })
      });
      const result = await response.json();
      if (result.success == true) {
        localStorage.setItem("access_token", result.accessToken);
        localStorage.setItem("token", result.accessToken);
      }
      return result.accessToken;
    } catch (error) { 
      console.log(error.message);
      return false
    }
  }
  return await generateRefreshToken();
}

export const FileUploadAPI = async (data, callback) => {
  try {
    console.log("dataaaaaaaaaaaaaaa", data);
    const response = await API.post(apiURL + "/upload", data);
    console.log("FileUploadAPI", response.data)
    callback(response.data);
  } catch (e) {
    console.log("error", e);
  }
}

export const LoginAPI = async (data, callback) => {
    try {
        const response = await API.post(apiURL + "/login", data);
        console.log("response.data", response.data)
        callback(response.data);
    } catch (error) {
        callback(error.response?.data || { success: false });
    }
};

export const GetAPI = async (url, callback) => {
  await API.get(apiURL + url)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      // callback(error.response.data);
    });
};

export const PostAPI = async (paramsOrUrl, dataOrCb, maybeCb) => {
  let url;
  let data;
  let callback;

  if (typeof paramsOrUrl === 'string') {
    url = paramsOrUrl;
    data = dataOrCb;
    callback = maybeCb;
  } else if (paramsOrUrl && typeof paramsOrUrl === 'object') {
    url = paramsOrUrl.url;
    data = paramsOrUrl.data;
    callback = dataOrCb;
  } else {
    callback = maybeCb || (() => {});
    return callback({ success: false, error: 'Invalid PostAPI arguments' });
  }

  if (typeof callback !== 'function') callback = () => {};

  try {
    const response = await API.post(apiURL + url, data);
    console.log("POSTAPI response?.data :   ", response?.data)

    callback(response?.data);
  } catch (error) {
    callback(error);
    console.error(error);
    return error;
  }
};

export const PatchAPI = async ({ url, data }, callback) => {
  await API.patch(apiURL + url, data)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response?.data);
    });
};

export const DeleteAPI = async ({ url, data }, callback) => {
  await API.delete(apiURL + url, { data: data })
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response?.data);
    });
};

export const Delete_params = async (url, callback) => {
  await API.delete(apiURL + url)
    .then(function (response) {
      callback(response.data);
    })
    .catch(function (error) {
      callback(error.response?.data);
    });
};

export const PutAPI = async ({ url, data }, callback) => {
  await API.put(apiURL + url, data)
    .then(function (response) {
      callback(response?.data);
    })
    .catch(function (error) {
      callback(error);
      console.log(error);
    });
};